import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CategoryService } from '../../services/category.service';
import { EnfoqueService } from '../../services/enfoque.service';
import { EjecutorService } from '../../services/ejecutor.service';
import { ZoneService } from '../../services/zone.service';
import { LoginService } from '../../services/login.service';
import { ToastrService } from 'ngx-toastr';
import { EventEmitterService } from '../../services/event-emitter.service';
import { EventBiService } from 'src/app/services/event-bi.service';
import { EventCapacitacionService } from 'src/app/services/event-capacitacion.service';
import { EventNavbarService } from 'src/app/services/event-navbar.service';
import { EventMantenedoresService } from 'src/app/services/event-mantenedores.service';
import { EventCargaMasivaService } from 'src/app/services/carga-masiva.service';
import { EventAprobacionMasivaService } from 'src/app/services/event-aprobacion-masiva.service';
import { Router } from '@angular/router';
export class LeftpanelComponent {
    constructor(modalService, navigationService, categoryService, enfoqueService, ejecutorService, zoneService, toastr, eventEmitterService, eventBiService, eventMantenedoresService, eventCapacitacionService, eventNavbarService, eventCargaMasivaService, eventAprobacionMasivaService, loginService, router) {
        this.modalService = modalService;
        this.navigationService = navigationService;
        this.categoryService = categoryService;
        this.enfoqueService = enfoqueService;
        this.ejecutorService = ejecutorService;
        this.zoneService = zoneService;
        this.toastr = toastr;
        this.eventEmitterService = eventEmitterService;
        this.eventBiService = eventBiService;
        this.eventMantenedoresService = eventMantenedoresService;
        this.eventCapacitacionService = eventCapacitacionService;
        this.eventNavbarService = eventNavbarService;
        this.eventCargaMasivaService = eventCargaMasivaService;
        this.eventAprobacionMasivaService = eventAprobacionMasivaService;
        this.loginService = loginService;
        this.router = router;
        this.isCollapsed = false;
        this.usuarioHabilitado = false;
        this.sidebarIsOpen = false;
        this.showPlan = true;
        this.loading = false;
        this.isIndicatorsCollapsed = false;
        this.isMobile = false;
        this.isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.loginService.obtenerPermisosMenu('inicio').then((response) => {
                this.rolid = response.data.rolId;
            });
            if (this.isMobile) {
                this.sidebarIsOpen = true;
            }
            else {
                this.sidebarIsOpen = false;
            }
            this.loginData = JSON.parse(sessionStorage.getItem('loginData'));
            this.nombreUsuario = this.loginData.usertableentity.nombreTrabajador;
            this.rutContratista = this.loginData.usertableentity.rutContratista;
            this.hidePlanificar();
            if (sessionStorage.getItem('rolid') == "3") {
                this.estaHabilitado(sessionStorage.getItem('userid'));
            }
            if (this.eventNavbarService.subsVar == undefined) {
                this.eventNavbarService.subsVar = this.eventNavbarService.
                    invokeFirstComponentFunction.subscribe((name) => {
                    this.toggleSidebar(false);
                });
            }
            this.loginService.obtenerMenuUsuario().then((response) => {
                console.log('Response Menu Usuario');
                console.log(response.data);
                this.menuUser = response.data;
                console.log(this.menuUser);
                //this.methodsForMenu();
                console.log(this.menuUser);
            });
        });
    }
    toggleSidebar(openSidebar) {
        if (this.isMobile) {
            document.getElementById('sidebar').style.width = this.sidebarIsOpen ? '0px' : '100%';
            document.getElementById('sidebar').style['z-index'] = this.sidebarIsOpen ? '0px' : '10';
            document.getElementById('close-arrow').style['z-index'] = this.sidebarIsOpen ? '0px' : '11';
        }
        else {
            if (openSidebar) {
                if (this.sidebarIsOpen) {
                    Array.from(document.getElementsByClassName('navbar-toggle')).forEach(element => {
                        element.style['display'] = '';
                    });
                    Array.from(document.getElementsByClassName('menu-hidden')).forEach(element => {
                        element.style['display'] = 'none';
                    });
                    document.getElementById('sidebar').style.width = '50px';
                }
                else {
                    Array.from(document.getElementsByClassName('navbar-toggle')).forEach(element => {
                        element.style['display'] = 'none';
                    });
                    Array.from(document.getElementsByClassName('menu-hidden')).forEach(element => {
                        element.style['display'] = '';
                    });
                    document.getElementById('sidebar').style.width = '250px';
                    document.getElementById('sidebar').style['z-index'] = '10';
                    document.getElementById('close-arrow').style['z-index'] = '11';
                }
                // document.querySelector<HTMLElement>('.sidebar div span').style.display = !this.sidebarIsOpen ? 'inline' : 'none';
                // document.getElementById('sidebar').style.width = this.sidebarIsOpen ? '0px' : '230px';
                // document.getElementById('sidebar').style.width = !this.sidebarIsOpen ? '0px' : '50px';
                // document.getElementById('sidebar').style.display = !this.sidebarIsOpen ? 'inline' : 'none';
                // document.getElementById('app-div').style['margin-left'] = this.sidebarIsOpen ? '0px' : '230px';
            }
        }
        this.sidebarIsOpen = !this.sidebarIsOpen;
    }
    onPageSelected(path) {
        this.navigationService.goTo(path);
    }
    logout() {
        if (this.sidebarIsOpen) {
            this.toggleSidebar(false);
        }
        sessionStorage.removeItem('loginData');
        sessionStorage.clear();
        this.navigationService.goTo('/login');
        if (sessionStorage.getItem('logout') === null || sessionStorage.getItem('logout') === 'false') {
            sessionStorage.setItem('logout', 'true');
        }
    }
    getCategories() {
        return new Promise((resolve, reject) => {
            this.categoryService.listWithFocos()
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getEnfoques() {
        return new Promise((resolve, reject) => {
            this.enfoqueService.list()
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getEjecutores() {
        return new Promise((resolve, reject) => {
            this.ejecutorService.listWithRelatores()
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getZonas() {
        return new Promise((resolve, reject) => {
            this.zoneService.getZonas()
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    estaHabilitado(user) {
        this.categoryService.estaHabilitado(user).then(response => {
            this.usuarioHabilitado = response;
        })
            .catch(error => {
            this.usuarioHabilitado = false;
        });
        /*return new Promise(async (resolve, reject) => {
          await this.categoryService.estaHabilitado(user)
            .then(response => {
              this.usuarioHabilitado = response;
              resolve.bind(response);
            })
            .catch(error => {
              reject.bind(error);
              this.usuarioHabilitado = false;
            });
        });*/
    }
    openModal(modal, mode) {
        $("#show-loading").css('display', 'grid');
        this.loading = true;
        const modalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' };
        Promise.all([
            this.getCategories(),
            this.getEnfoques(),
            this.getEjecutores(),
            this.getZonas(),
        ])
            .then(results => {
            this.categoriesWithFocos = results[0];
            this.enfoques = results[1];
            this.ejecutoresWithRelatores = results[2];
            this.zonas = results[3];
            this.creationMode = mode;
            this.loading = false;
            this.modalService.open(modal, modalOptions);
            $("#show-loading").css('display', 'none');
        })
            .catch(error => console.error(error));
        // $("#show-loading").css('display', 'none')
    }
    openModalCargaPlan(modal) {
        const modalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' };
        this.modalService.open(modal, modalOptions);
    }
    onSave() {
        this.eventEmitterService.onFirstComponentButtonClick();
        this.eventEmitterService.onIndicatorsRefresh();
        this.eventEmitterService.onCalendarRefresh();
    }
    onSaveAccept() {
        this.eventEmitterService.onFirstComponentButtonClick();
        this.eventEmitterService.onIndicatorsRefresh();
        this.eventEmitterService.onCalendarRefresh();
    }
    openComponenteBi() {
        this.isIndicatorsCollapsed = true;
        if (this.sidebarIsOpen) {
            this.toggleSidebar(false);
        }
        this.eventBiService.onBiComponentButtonClick();
    }
    openMantenedores() {
        this.eventMantenedoresService.onMantenedoresComponentButtonClick();
        this.router.navigate(['/mantenedores']);
    }
    openComponentDashboard() {
        this.router.navigate(['/dashboard']);
    }
    openComponentDashboardContratista() {
        this.router.navigate(['/dashboard-contratista']);
    }
    openComponentCapacitaciones() {
        this.eventCapacitacionService.onCapacitacionesComponentButtonClick();
        this.router.navigate(['/capacitaciones']);
    }
    openComponentCargaMasiva() {
        // console.log('Periodo de creacion finalizado desde Left Panel')
        // this.usuarioHabilitado = false;
        // const siempre_edita = this.loginData.usertableentity.roleId == 1 || this.loginData.usertableentity.roleId == 2 || this.loginData.usertableentity.roleId == 3 ? true : false;
        // this.estaHabilitado(this.loginData.usertableentity.roleId);
        /*if(!this.usuarioHabilitado && !siempre_edita){
          this.toastr.info('Lo sentimos, el periodo de creación de capacitaciones ha finalizado', 'Advertencia');
    
        }else{
          this.eventCargaMasivaService.onCargaMasivaComponentButtonClick();
          this.router.navigate(['/carga-masiva']);
        }*/
        // setTimeout(() => {
        //   if (this.usuarioHabilitado && siempre_edita) {
        //     this.eventCargaMasivaService.onCargaMasivaComponentButtonClick();
        //     this.router.navigate(['/carga-masiva']);
        //   } else {
        //     this.toastr.info('Lo sentimos, el periodo de creación de capacitaciones ha finalizado', 'Advertencia');
        //   }
        // }, 1000);
        this.eventCargaMasivaService.onCargaMasivaComponentButtonClick();
        this.router.navigate(['/carga-masiva']);
    }
    openAprobacion() {
        this.eventAprobacionMasivaService.onAprobacionMasivaComponentButtonClick();
        this.router.navigate(['/aprobacion']);
    }
    hidePlanificar() {
        const configuration = this.loginData.configurationTableEntity;
        const siempre_edita = this.loginData.usertableentity.planificaSiempre;
        const abreModal = configuration.map((x) => x.codigo == "FECHA_PLAN");
        if ((!abreModal || abreModal == "") && !siempre_edita) {
            this.showPlan = false;
        }
    }
    collapseIndicators() {
        this.isIndicatorsCollapsed = !this.isIndicatorsCollapsed;
        this.openComponentCapacitaciones();
    }
    clickSubMenu() {
        let header = document.getElementById("collapseExample");
        let btns = header.getElementsByClassName("submenu-item");
        for (let i = 0; i < btns.length; i++) {
            btns[i].addEventListener("click", function () {
                let current = document.getElementsByClassName("active");
                current[0].className = current[0].className.replace(" active", "");
                this.className += " active";
            });
        }
    }
    methodsForMenu() {
        this.menuUser.forEach((menu) => {
            this.openComponentDashboardBtn = this.openComponentDashboard;
            this.openComponentCapacitacionesBtn = this.openComponentCapacitaciones;
            if (menu.codeMenu == 'inicio') {
                menu.methodClick = this.openComponentDashboardBtn;
            }
            if (menu.codeMenu == 'planificacion') {
                menu.methodClick = this.openComponentCapacitacionesBtn;
                if (menu.subMenu.length > 0) {
                    menu.subMenu.forEach((subMenu) => {
                        if (subMenu.codeMenu == 'generacionPlanBase') {
                            subMenu.methodClick = "openModalCargaPlan(cargaPlanModal)";
                        }
                        if (subMenu.codeMenu == 'cargarPlanCapacitacion') {
                            subMenu.methodClick = "openComponentCargaMasiva()";
                        }
                        if (subMenu.codeMenu == 'revisionPlanes') {
                            subMenu.methodClick = "this.openAprobacion()";
                        }
                        if (subMenu.codeMenu == 'anadirReforzamiento') {
                            subMenu.methodClick = "openModal(capacitacionModal, 'reforzamiento')";
                        }
                    });
                }
            }
            if (menu.codeMenu == 'mantenedores') {
                menu.subMenu = [];
                menu.methodClick = "openMantenedores()";
            }
        });
    }
}
